module.exports = __webpack_public_path__ + "img/logo2.5b1e9953.png";